<template>
  <ValidationObserver ref="form" v-slot="{ invalid }">
    <v-card v-bind="$attrs" :disabled="loading">
      <v-form @submit.prevent="submit">
        <v-card-title>
          Formulário de Invoices
          <v-spacer></v-spacer>
          <v-btn v-if="dialog" @click="cancel" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <ValidationProvider
            :rules="{ required: true, min_value: 1 }"
            v-slot="{ errors }"
            name="número"
          >
            <v-text-field
              v-model="form.invoice_number"
              type="number"
              label="Número"
              style="max-width: 120px"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :rules="{ required: true }"
            v-slot="{ errors }"
            name="cliente"
          >
            <v-autocomplete
              v-model="form.client_id"
              label="Cliente"
              :items="clients"
              item-text="name"
              item-value="id"
              :error-messages="errors"
              autofocus
            ></v-autocomplete>
          </ValidationProvider>

          <v-row>
            <v-col>
              <ValidationProvider
                :rules="{ required: true, min_value: 0.01 }"
                v-slot="{ errors }"
                name="valor"
              >
                <MoneyInput
                  v-model="form.amount"
                  @keydown.enter="submit"
                  label="Valor"
                  :options="{
                    locale: 'pt-PT',
                    prefix: '€',
                    suffix: '',
                    length: 11,
                    precision: 2
                  }"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                :rules="{ required: true }"
                v-slot="{ errors }"
                name="data"
              >
                <v-text-field
                  v-model="form.date"
                  type="date"
                  label="Data"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">Cancelar</v-btn>
          <v-btn
            type="submit"
            color="primary"
            :disabled="invalid"
            :loading="loading"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </ValidationObserver>
</template>

<script>
import MoneyInput from "@/components/MoneyInput";
import DateTimeMixin from "@/mixins/DateTimeMixin";

export default {
  components: { MoneyInput },

  mixins: [DateTimeMixin],

  props: {
    clients: Array,
    dialog: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      form: {}
    };
  },

  methods: {
    init(initial_data) {
      this.loading = false;
      this.form = {
        ...initial_data
      };
      this.$refs.form.reset();
    },
    cancel() {
      this.$emit("cancel");
    },
    async submit() {
      if (!(await this.$refs.form.validate())) return;

      console.log({
        rawDate: this.form.date,
        stringDate: this.getDateString(this.form.date)
      });

      this.$emit("submit", {
        ...this.form,
        date: this.getDateString(this.form.date)
      });
    }
  }
};
</script>
